import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

export interface StopSimulationDialogProps {
  description: string;
  onClickCancel: () => void;
  onClickStop: () => void;
  open: boolean;
  title: string;
}

const StopSimulationDialog = ({ description, onClickCancel, onClickStop, open, title }: StopSimulationDialogProps) => (
  <Dialog open={open} onClose={onClickCancel}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{description}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClickCancel}>Cancel</Button>
      <Button onClick={onClickStop} variant="contained">
        {title}
      </Button>
    </DialogActions>
  </Dialog>
);

export default StopSimulationDialog;
